module.exports = __webpack_public_path__ + "static/media/rank5.d58ae34b.svg";